import { Drawer } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import CloseAlerts from '../../alerts/assets/svg/CloseAlerts';
import styled from 'styled-components';
import { secondaryFont, primaryHeadingColor, wMBold, maxWidth, retina, maxMobile, primaryColor, primaryFont, greyColor, wLight, wMedium, scrollbar, SecondaryColorTwo } from '../../../Utils/utilsStyle';
import AlertsSearch from '../../alerts/components/AlertsSearch';
import NewClusterWidget from './NewClusterWidget';
import CreateNewClusterSection from './CreateNewClusterSection';
import ClustersDisplayWidget from './ClustersDisplayWidget';
import InfiniteScroll from 'react-infinite-scroll-component';
import GlobalButton from '../../common/components/GlobalButton';
import { useDispatch, useSelector } from 'react-redux';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import { Clusters, SelectedCluster } from '../../../Types/ClustersTypes';
import { selectAllClusterLoading, selectAllClusters, selectClusterCount, selectClusterDrawerOpen, selectClusterPageNumber, selectSelectedClusters } from '../../../Selector/ClustersSelector';
import GroupsDisplaySkeleton from '../../common/skeleton/GroupsDisplaySkeleton';
import ShareGroupPeopleModal from '../../common/modal/ShareGroupPeopleModal';

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 32px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMBold};
  margin-bottom: 0px;
  display: inline-block;
  padding: 0px 33px 16px 33px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 28px;
    line-height: 30px;
  }
  @media all and (max-width: ${maxMobile}){
    padding: 0px 16px;
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 8px;
  }
`;
const ContentWrapper = styled.div`
  /* .drawer-body {
    padding: 0px 33px;
    .search-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 16px;
      margin-bottom: 24px;
      .search-box {
        width: 100%;
        .search-wrapper {
          .ant-input-affix-wrapper {
            height: 32px;
            .ant-input {
              &::placeholder {
                color:${greyColor};
                font-family: ${primaryFont};
                font-size: 14px;
                font-weight: ${wLight};
                line-height: normal;
                letter-spacing: -0.4px;
              }
            }
          }
        }
      }
      .share-btn {
        height: 30px;
        background: ${primaryColor};
        border: 1px solid ${primaryColor};
        border-radius: 22px;
        color: #FFF;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMBold};
        line-height: 13px;
        letter-spacing: -0.4px;
        padding: 7px 13px;
      }
    }
  } */
   .drawer-body {
       /* padding: 0px 33px; */
       display: flex;
       flex-direction: column;
       height : calc(100vh - 140px) ;
       .content-box {
         flex: 1;
         min-height: 0;
         display: flex;
         flex-direction: column;
         padding: 2px 33px;
         .search-div {
           display: flex;
           align-items: center;
           justify-content: space-between;
           column-gap: 16px;
           margin-bottom: 16px;
           flex-shrink: 0;
           .search-box {
             width: 100%;
             .search-wrapper {
               .ant-input-affix-wrapper {
                 height: 32px;
                 .ant-input {
                   max-width: 370px;
                   &::placeholder {
                     color: #7E7E7E;
                     font-family: Roboto;
                     font-size: 14px;
                     font-style: normal;
                     font-weight: 400;
                     line-height: normal;
                     letter-spacing: -0.4px;
                   }
                 }
               }
               .cross-icon {
                 top: 8px;
                 right: 12px;
               }
             }
           }
           .share-btn {
             height: 30px;
             background: ${primaryColor};
             border: 1px solid ${primaryColor};
             border-radius: 22px;
             color: #FFF;
             font-family: ${primaryFont};
             font-size: 14px;
             font-weight: ${wMBold};
             line-height: 13px;
             letter-spacing: -0.4px;
             padding: 7px 13px;
             cursor: pointer;
           }
         }
         .clusters-widget-section {
           min-height: 0;
           flex: 1;
           #cluster-widget-scrollable-div {
            ${scrollbar};
            height: 100%;
             border-radius: 0px !important;
             .infinite-for-cluster-section {
               .clusters-list {
                 display: flex;
                 flex-direction: column;
                 /* row-gap: 10px; */
                 padding: 2px 14px 0px 0px;
                 .skeleton {
                   display: flex;
                   flex-direction: column;
                   row-gap: 10px;
                   .box {
                     display: flex;
                     align-items: center;
                     column-gap: 12px;
                     padding: 14px 16px;
                     border-radius: 10px;
                     border: 1px solid #DADADA;
                     background: #FFF;
                     box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
                   }
                 }
               }
             }
           }
         }
       }
       .footer {
         display: flex;
         align-items: center;
         justify-content: space-between;
         height: 80px;
         background: #FFF;
         box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.14);
         padding: 0px 24px;
         .selected-count {
           display: flex;
           flex-direction: column;
           .count-section {
             display: flex;
             align-items: center;
             column-gap: 8px;
             .icon {
               width: 22px;
             }
             .text {
               color: ${primaryColor};
               font-family: ${primaryFont};
               font-size: 18px;
               font-weight: ${wMedium};
               line-height: normal;
             }
           }
           .limit-section {
             color: #6A6A6A;
             font-family: Roboto;
             font-size: 12px;
             font-style: normal;
             font-weight: 500;
             line-height: normal;
             margin-left: 31px;
             margin-top: -5px;
           }
           
         }
         .buttons-div {
           display: flex;
           align-items: center;
           column-gap: 8px;
         }
       }
     }
`
type Props = {
  toggleDrawer: () => void;
  mode: string;
  isAddDrawer?: boolean;
};

const defaultProps = {
  toggleDrawer: () => { },
  mode: "browse",
  isAddDrawer: false,
};
const DrawerAccountCluster = function DrawerAccountCluster(props: Props) {
  const dispatch = useDispatch();
  const { toggleDrawer, mode, isAddDrawer } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [shareMode, setShareMode] = useState(false);
  // const [selectedClusters, setSelectedClusters] = useState<SelectedCluster[]>([]);
  const selectedClusters = useSelector(selectSelectedClusters);
  const allClusters: Clusters[] = useSelector(selectAllClusters);
  const clustersLoading = useSelector(selectAllClusterLoading);
  const clusterCount = useSelector(selectClusterCount);
  const clusterPage = useSelector(selectClusterPageNumber);
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);

  const onSearching = (value: string) => {
    setSearchTerm(value);
  }
  const shareModeHandler = () => {
    setShareMode(true);
  }

  const cancelShareModeHandler = () => {
    setShareMode(false);
    dispatch(clusterActions.setSelectedClusters([]));
  }

  useEffect(() => {
    if (mode === 'browse' && clusterDrawerOpen) {
      dispatch(clusterActions.getAccountClusters({
        page: 1,
        ...(searchTerm && { search: searchTerm }),
      }));
    }
  }, [mode, clusterDrawerOpen, searchTerm])

  useEffect(() => {
    if (!clusterDrawerOpen) {
      setShareMode(false);
    }
  }, [clusterDrawerOpen])

  const fetchMore = () => {
    dispatch(clusterActions.getAccountClusters({
      page: clusterPage,
      ...(searchTerm && { search: searchTerm }),
    }))
  };

  const handleClusterSelect = (cluster: SelectedCluster) => {
    const exists = selectedClusters.some(
      (item) => item.clusterId === cluster.clusterId
    );

    const updatedClusters = exists
      ? selectedClusters.filter(
        (item) => item.clusterId !== cluster.clusterId
      )
      : [
        ...selectedClusters,
        {
          clusterId: cluster.clusterId,
          clusterName: cluster.clusterName,
        },
      ];

    dispatch(clusterActions.setSelectedClusters(updatedClusters));
  };
  // const handleClusterSelect = (
  //   cluster: { cluster_id: number; cluster_name: string }
  // ) => {
  //   setSelectedClusters((prev) => {
  //     let updatedClusters: SelectedCluster[];

  //     const exists = prev.some(
  //       (item) => item.cluster_id === cluster.cluster_id
  //     );

  //     if (exists) {
  //       updatedClusters = prev.filter(
  //         (item) => item.cluster_id !== cluster.cluster_id
  //       );
  //     } else {
  //       updatedClusters = [
  //         ...prev,
  //         {
  //           cluster_id: cluster.cluster_id,
  //           cluster_name: cluster.cluster_name,
  //         },
  //       ];
  //     }

  //     dispatch(clusterActions.setSelectedClusters(updatedClusters));

  //     return updatedClusters;
  //   });
  // };

  // const handleClusterSelect = (
  //   cluster: { cluster_id: number; cluster_name: string }
  // ) => {
  //   setSelectedClusters((prev) => {
  //     const exists = prev.some(
  //       (item) => item.cluster_id === cluster.cluster_id
  //     );

  //     if (exists) {
  //       return prev.filter(
  //         (item) => item.cluster_id !== cluster.cluster_id
  //       );
  //     }

  //     return [
  //       ...prev,
  //       {
  //         cluster_id: cluster.cluster_id,
  //         cluster_name: cluster.cluster_name,
  //       },
  //     ];
  //   });
  //   dispatch(clusterActions.setSelectedClusters(selectedClusters));
  // };
  // const handleClusterSelect = (clusterId: number) => {
  //   setSelectedClusters((prev) => {
  //     if (prev.includes(clusterId)) {
  //       return prev.filter((id) => id !== clusterId);
  //     }

  //     return [...prev, clusterId]
  //   })
  // };

  const multipleShareHandler = () => {
    console.log("SelectedClusters:", selectedClusters);
  }

  useEffect(() => {
    const node = document.querySelector('body');
    return clusterDrawerOpen ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [clusterDrawerOpen])

  return (
    <Drawer
      placement="right"
      closable={true}
      onClose={toggleDrawer}
      open={clusterDrawerOpen}
      width={530}
      rootClassName="drawer-account-cluster"
      extra={(
        <span onClick={() => toggleDrawer()} onKeyPress={() => toggleDrawer()} tabIndex={0} role="button" aria-label="close" className="close-alerts"><CloseAlerts /></span>
      )}
    >
      {
        mode === "browse" ? (
          <ContentWrapper>
            <div className="drawer-header">
              <Heading>All Clusters</Heading>
            </div>
            <div className="drawer-body">
              <div className='content-box'>
                <div className="search-div">
                  <div className="search-box">
                    <AlertsSearch
                      placeholderText="Search your Cluster..."
                      query={searchTerm}
                      loading={clustersLoading}
                      onSearching={onSearching}
                      margin="0px"
                      height="30px"
                    />
                  </div>
                  <div className="share-btn" onClick={shareModeHandler} role="button" tabIndex={0} aria-label="share">
                    Share
                  </div>
                </div>
                <div className="clusters-widget-section">
                  <div id='cluster-widget-scrollable-div'>
                    <InfiniteScroll
                      next={fetchMore}
                      hasMore
                      loader={false}
                      dataLength={allClusters.length}
                      className="o-x-hidden o-y-hidden infinite-for-cluster-section"
                      scrollableTarget="cluster-widget-scrollable-div"
                    >
                      <div className='clusters-list'>
                        {
                          allClusters.length > 0 &&
                          allClusters.map((cluster) => {
                            return (
                              <ClustersDisplayWidget
                                clusterName={cluster.clusterName}
                                clusterId={cluster.clusterId}
                                sharedBy={cluster.sharedByData}
                                isShared={cluster.sharedByData !== null}
                                companies={cluster.companiesData}
                                clusterPersona={cluster.personality}
                                shareClusterCheckBox={shareMode}
                                createdBy={cluster.ownerData}
                                isChecked={selectedClusters.some(
                                  (item) => item.clusterId === cluster.clusterId
                                )}
                                onSelectCluster={() =>
                                  handleClusterSelect({
                                    clusterId: cluster.clusterId,
                                    clusterName: cluster.clusterName,
                                  })
                                }
                              />
                            )
                          })
                        }
                        {
                          clustersLoading && (
                            <div className='skeleton'>
                              {
                                [1, 2, 3, 4, 5].map(() => <GroupsDisplaySkeleton border />)
                              }
                            </div>
                          )
                        }
                      </div>
                    </InfiniteScroll>
                  </div>
                </div>
              </div>
              {
                shareMode && (
                  <div className='footer'>
                    <div className='selected-count'>
                      <div className='count-section'>
                        {
                          selectedClusters.length === 0 ? (
                            <></>
                          ) : (
                            <span className='text'>Account selected</span>
                          )
                        }
                      </div>
                    </div>
                    <div className='buttons-div'>
                      <GlobalButton
                        title='Cancel'
                        outlineColor={primaryColor}
                        textColor={primaryColor}
                        innerSpace='9px 21px'
                        bgColor='#fff'
                        height='36px'
                        borderRadius='18px'
                        buttonClassName='cancel-btn'
                        onButtonClick={cancelShareModeHandler}
                      />
                      <ShareGroupPeopleModal
                        iconMode={false}
                        inClusterMode={true}
                      />
                      {/* <GlobalButton
                        title='Share Groups'
                        outlineColor={primaryColor}
                        textColor='#fff'
                        innerSpace='9px 21px'
                        bgColor={primaryColor}
                        height='36px'
                        borderRadius='18px'
                        buttonClassName='create-btn'
                        disabled={selectedClusters.length === 0}
                        onButtonClick={multipleShareHandler}
                      /> */}
                    </div>
                  </div>
                )
              }

            </div>
          </ContentWrapper>
        ) : (
          <CreateNewClusterSection
            visible={clusterDrawerOpen}
            isAddDrawer={isAddDrawer}
          />
        )
      }

    </Drawer>
  );
};
DrawerAccountCluster.defaultProps = defaultProps;
export default DrawerAccountCluster;
